import React, { useEffect, useState, useCallback } from "react";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Scatter } from "react-chartjs-2";
import { calculatePercj, calculatePlayerStats } from "../lib/cabbStats";
import { addModal } from "../lib/addModal";
import annotationPlugin from "chartjs-plugin-annotation";
import { DragabbleTest } from "../containers";
import { SharePopup } from "../components";

ChartJS.register(
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  annotationPlugin
);

export default function Test({ appData }) {
  const [games, setGames] = useState([]);
  const [dataSet, setDataset] = useState([]);
  const [playByPlayData, setPlayByPlayData] = useState([]);
  const [lineups, setLineups] = useState([]);

  const footer = (tooltipItems) => {
    let off = 0;
    let deff = 0;
    let name;
    tooltipItems.forEach(function (tooltipItem) {
      off = tooltipItem.parsed.x;
      deff = tooltipItem.parsed.y;
      name = tooltipItem.raw.label;
    });
    return name + " Off: " + off + ", Deff: " + deff;
  };

  const minYAxisValue = Math.min(...dataSet.map((v) => v.y)) - 3;
  const maxYAxisValue = Math.max(...dataSet.map((v) => v.y)) + 3;
  const maxXAxisValue = Math.max(...dataSet.map((v) => v.x)) + 3;
  const minXAxisValue = Math.min(...dataSet.map((v) => v.x)) - 3;

  let offA = 0;
  let deffA = 0;

  // Calcular la suma total de `y` en `dataSet`
  dataSet.forEach((v) => {
    offA += v.y;
    deffA += v.x;
  });

  // Calcular el promedio
  const averageY = offA / dataSet.length;
  const averageX = deffA / dataSet.length;

  const annotation1 = {
    type: "line",
    borderColor: "gray",
    borderWidth: 2,
    borderDash: [10, 10],
    label: {
      backgroundColor: "red",
      content: "Test Label",
      display: true,
    },
    scaleID: "left-y-axis",
    value: averageY,
  };
  const annotation2 = {
    type: "line",
    borderColor: "lightgray",
    borderWidth: 2,
    borderDash: [10, 10],
    label: {
      backgroundColor: "red",
      content: "Test Label",
      display: true,
    },
    scaleID: "right-x-axis",
    value: averageX,
  };
  const options = {
    type: "scatter",
    backgroundColor: "red",
    scales: {
      "left-y-axis": {
        type: "linear",
        position: "left",
        min: minYAxisValue,
        max: maxYAxisValue,
        reverse: true,
      },
      "right-x-axis": {
        type: "linear",
        position: "bottom",
        min: minXAxisValue,
        max: maxXAxisValue,
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          footer: footer,
        },
      },
      annotation: {
        annotations: {
          annotation1,
          annotation2,
        },
      },
    },
  };

  const dataChart = {
    datasets: [
      {
        label: "Eficinecia ofensiva vs eficiencia defensiva",
        data: dataSet.map((v) => ({ x: v.x, y: v.y, label: v.label })),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 1)",
        pointStyle: dataSet.map((png) => {
          const image = new Image(50, 50);
          image.src = `/assets/teams-logos/${png.label}.png`;
          return image;
        }),
      },
    ],
  };

  useEffect(() => {
    // fetchPlayByPlayData();
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://deportactico-vercel-serverless.vercel.app/api/gamesByleague?season=2024/2025&league=LNB`
        );
        const result = await response.json();
        setGames(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  async function fetchLineupAnalysis() {
    const filters = {
      season: "2024/2025",
      league: "LNB",
      phase: null,
      team: "team123",
    };
    const response = await fetch(
      `https://deportactico-vercel-serverless.vercel.app/api/lineups`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({ filters }),
      }
    );
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      console.log(message);
      return;
    }
    const record = await response.json();
    if (!record) {
      console.log(`Record not found`);
      return;
    } else if (record) {
    }
  }

  useEffect(() => {
    let teamsArr = [];
    let data = [];
    let labels = [];

    if (games.length > 0) {
      appData.teams?.forEach((element) => {
        if (element.league === "LNB") {
          teamsArr.push({
            _id: element._id,
            name: element.name,
            offValue: calculatePercj(games, element._id, "OFE").toFixed(1),
            deffValue: calculatePercj(games, element._id, "DFE").toFixed(1),
          });
        }
      });

      teamsArr.sort((a, b) => b.value - a.value);
      teamsArr.forEach((e) => {
        labels.push(e.name);
        data.push({
          x: parseFloat(e.offValue),
          y: parseFloat(e.deffValue),
          label: e.name,
        });
      });
      setDataset(data);
    }
  }, [appData, games]);

  const fetchPlayByPlayData = useCallback(async (season, league) => {
    try {
      const response = await fetch(
        `http://localhost:5001/api/pbp?season=2024/2025&league=LNB`
      );
      const result = await response.json();
      setPlayByPlayData(result);
    } catch (err) {
      console.log("Error fetching play-by-play data", err);
    } finally {
    }
  }, []);

  const analyzeLineups = useCallback(() => {
    // Aquí implementaremos la lógica para analizar las alineaciones
    // usando los datos de play-by-play
    const lineupStats = {};

    playByPlayData.forEach((game) => {
      // Lógica para procesar cada juego y actualizar las estadísticas de alineación
      // Esta es una implementación simplificada. Necesitarás ajustarla según tus necesidades específicas.
      let currentLineup = [];
      let lastSubstitutionTime = "00:00";

      game.plays.forEach((play) => {
        if (play.action === "Sustitución") {
          // Actualizar las estadísticas de la alineación actual antes de cambiarla
          updateLineupStats(
            lineupStats,
            currentLineup,
            lastSubstitutionTime,
            play.time
          );

          // Actualizar la alineación
          if (play.action.includes("entra")) {
            currentLineup.push(play.player);
          } else {
            currentLineup = currentLineup.filter((p) => p !== play.player);
          }
          lastSubstitutionTime = play.time;
        } else {
          // Actualizar otras estadísticas basadas en la acción
          updateActionStats(lineupStats, currentLineup, play);
        }
      });
    });

    setLineups(Object.values(lineupStats));
  }, [playByPlayData]);
  useEffect(() => {
    if (playByPlayData.length > 0) {
      analyzeLineups();
    }
  }, [playByPlayData, analyzeLineups]);

  const updateLineupStats = (stats, lineup, startTime, endTime) => {
    if (lineup.length !== 5) return;

    const lineupKey = lineup.sort().join("-");
    if (!stats[lineupKey]) {
      stats[lineupKey] = {
        lineup_str: lineupKey,
        team_id: "", // Necesitarás determinar esto
        games_played: 1,
        minutes_played: 0,
        points: 0,
        rebounds: 0,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
      };
    }

    // Calcular minutos jugados
    const minutesPlayed = calculateTimeDifference(startTime, endTime);
    stats[lineupKey].minutes_played += minutesPlayed;
  };

  const updateActionStats = (stats, lineup, play) => {
    if (lineup.length !== 5) return;

    const lineupKey = lineup.sort().join("-");
    if (!stats[lineupKey]) return;

    // Actualizar estadísticas basadas en la acción
    switch (play.action) {
      case "Canasta":
        stats[lineupKey].points += 2;
        break;
      case "Triple":
        stats[lineupKey].points += 3;
        break;
      case "Tiro Libre":
        stats[lineupKey].points += 1;
        break;
      case "Rebote":
        stats[lineupKey].rebounds += 1;
        break;
      case "Asistencia":
        stats[lineupKey].assists += 1;
        break;
      case "Robo":
        stats[lineupKey].steals += 1;
        break;
      case "Tapón":
        stats[lineupKey].blocks += 1;
        break;
      case "Pérdida":
        stats[lineupKey].turnovers += 1;
        break;
    }
  };

  const calculateTimeDifference = (start, end) => {
    return 0; // Placeholder
  };

  return (
    <div style={{ backgroundColor: "rgb(249 238 214)" }}>
      <h1>Test page</h1>
      <Scatter options={options} data={dataChart} />
      {/* <DragabbleTest /> */}
      <SharePopup isShare={true} />
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">Análisis de Alineaciones</h1>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead>
              <tr>
                <th className="px-4 py-2">Alineación</th>
                <th className="px-4 py-2">Equipo</th>
                <th className="px-4 py-2">Partidos</th>
                <th className="px-4 py-2">Minutos</th>
                <th className="px-4 py-2">Puntos</th>
                <th className="px-4 py-2">Rebotes</th>
                <th className="px-4 py-2">Asistencias</th>
                <th className="px-4 py-2">Robos</th>
                <th className="px-4 py-2">Tapones</th>
                <th className="px-4 py-2">Pérdidas</th>
              </tr>
            </thead>
            <tbody>
              {lineups.map((lineup, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-gray-100" : ""}
                >
                  <td className="border px-4 py-2">{lineup.lineup_str}</td>
                  <td className="border px-4 py-2">{lineup.team_id}</td>
                  <td className="border px-4 py-2">{lineup.games_played}</td>
                  <td className="border px-4 py-2">
                    {lineup.minutes_played.toFixed(2)}
                  </td>
                  <td className="border px-4 py-2">{lineup.points}</td>
                  <td className="border px-4 py-2">{lineup.rebounds}</td>
                  <td className="border px-4 py-2">{lineup.assists}</td>
                  <td className="border px-4 py-2">{lineup.steals}</td>
                  <td className="border px-4 py-2">{lineup.blocks}</td>
                  <td className="border px-4 py-2">{lineup.turnovers}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
